import React from 'react';


export default function Toolbar (props) {
    return (
        <div className="toolbar">
            <button onClick={props.onRefresh}>refresh</button>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/toolbar.js